import * as React from 'react';
import { FelaComponent } from 'react-fela';
import { withUIETheme } from '../uietheme/withUIETheme';
const Header = ({ uieTheme, children }) => {
    const style = {
        backgroundColor: uieTheme.colors.bgPanelHeader,
        textTransform: 'uppercase',
        ...uieTheme.fontStyles.headline,
        fontSize: uieTheme.fontSizes.small,
        color: uieTheme.colors.textPanelHeading,
        padding: uieTheme.spacing.space2,
        borderRadius: '1px',
        marginBottom: uieTheme.spacing.space2,
    };
    return React.createElement(FelaComponent, { style: style }, children);
};
const Container = ({ uieTheme, children }) => {
    const style = {
        backgroundColor: uieTheme.colors.bgContent,
        borderRadius: '3px',
        marginBottom: '2rem',
        width: '100%',
    };
    return React.createElement(FelaComponent, { style: style }, children);
};
const Content = ({ uieTheme, children }) => {
    const style = {
        paddingLeft: uieTheme.spacing.space2,
        paddingTop: uieTheme.spacing.space2,
    };
    return React.createElement(FelaComponent, { style: style }, children);
};
const FontStylePanelInternal = ({ uieTheme, name, children }) => {
    return (React.createElement(Container, { uieTheme: uieTheme },
        React.createElement(Header, { uieTheme: uieTheme }, name),
        React.createElement(Content, { uieTheme: uieTheme }, children)));
};
export const FontStylePanel = withUIETheme(FontStylePanelInternal);
//# sourceMappingURL=FontStylePanel.js.map